import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getPrettyTimeAgoFromNow } from '../../../Helpers/formatting';
import { openArtistModal, openChatOverlay } from '../../../Actions/UIActions';
import { UPDATE_CHAT_ERROR } from '../../../Actions/ChatActions';
import cn from 'classnames';

import './OpportunityChat.scss';

const OpportunityChat = props => {
  const { chat, openChatOverlay, openArtistModal, updateChat } = props;
  const { user } = chat;

  const hasUnreadMessage = !!chat.hasNewMessagesForBrand;

  const markAsRead = async () => {
    const res = await updateChat(chat, { hasNewMessagesForBrand: false });
    if (res.type === UPDATE_CHAT_ERROR) {
      window.ALERT.error('Error marking chat as read, please reload and try again.');
    }
  };

  const markAsUnread = async () => {
    const res = await updateChat(chat, { hasNewMessagesForBrand: true });
    if (res.type === UPDATE_CHAT_ERROR) {
      window.ALERT.error('Error marking chat as unread, please reload and try again.');
    }
  }

  const openChat = useCallback(() => {
    openChatOverlay({
      id: user.id,
      name: user.name,
      image: user.image
    });
  }, [openChatOverlay, user]);

  return (
    <div className='opportunity-chat-container'>
      <div className={cn('opportunity-chat-unread-indicator', {
        'hidden': !hasUnreadMessage
      })}>
        <div className='opportunity-chat-unread-icon' />
        <div className='opportunity-chat-unread-text'>New Message:</div>
      </div>
      <div className='opportunity-chat-header'>
        <img src={user.image} className='opportunity-chat-user-avatar' alt={user.name} onClick={() => openArtistModal(user)} />
        <div className='opportunity-chat-user-name' onClick={() => openArtistModal(user)}>
          {user.name}
        </div>
        <div className='opportunity-chat-last-message-time'>
          {`${getPrettyTimeAgoFromNow(chat.lastMessageTime)} ago`}
        </div>
      </div>
      <div className='opportunity-chat-body'>
        <div className='opportunity-chat-last-message-content-outer'>
          <div className='opportunity-chat-last-message-content-inner'>
            {chat.lastMessage}
          </div>
        </div>
        {hasUnreadMessage ? (
          <>
            <div className={'opportunity-chat-mark-as-read-button'} onClick={markAsRead}>
              Mark as Read
            </div>
            <div className={'opportunity-chat-reply-button'} onClick={openChat}>
              Reply
            </div>
          </>
        ) : (
          <>
            <div className={'opportunity-chat-mark-as-unread-button'} onClick={markAsUnread}>
              Mark as Unread
            </div>
            <div className={'opportunity-chat-open-chat-button'} onClick={openChat}>
              Open Chat
            </div>
          </>
        )}
      </div>
    </div>
  );
}

OpportunityChat.propTypes = {
  // From Outside
  chat: PropTypes.object.isRequired,

  // From inside
  openChatOverlay: PropTypes.func.isRequired,
  updateChat: PropTypes.func.isRequired
};

export default connect(null, {
  openChatOverlay,
  openArtistModal
})(OpportunityChat);
